import React, { PureComponent } from 'react';

export default class Loader extends PureComponent {
    state = {
        timerOver: false
    };

    componentDidMount() {
        this._ismounted = true;
        setTimeout(() => this._ismounted ? this.setState({timerOver: true}) : {}, 100);
    }

    componentWillUnmount() {
        this._ismounted = false;
    }

    render() {
        const { timerOver } = this.state;
        if (!timerOver) return null;

        return (
            <div className="loader-wrapper">
                <div className="loader-element">
                    <div className="loading2">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/Loader/Loader.jsx